import { transformNumber } from 'utils';

const transformToCurrency = (coins: number) => {
  const currency = coins / 100;

  return transformNumber(currency.toFixed(2));
};

export { transformToCurrency };
